import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import cx from "classnames";
import { withRouter } from "react-router-dom";
import Nav from "../AppNav/VerticalNavWrapper";

import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";

import PerfectScrollbar from "react-perfect-scrollbar";
import HeaderLogo from "../AppLogo";

import { setEnableMobileMenu } from "../../reducers/ThemeOptions";
import Skeleton from "react-loading-skeleton";

class AppSidebar extends Component {
  state = {
    showOffcanvas: false,
  };

  toggleMobileSidebar = () => {
    let { enableMobileMenu, setEnableMobileMenu } = this.props;
    setEnableMobileMenu(!enableMobileMenu);
  };
  componentDidMount() {
    this.checkOffcanvasParam();
  }
  componentDidUpdate(prevProps) {
    if (this.props.location.search !== prevProps.location.search) {
      this.checkOffcanvasParam();
    }
  }

  checkOffcanvasParam = () => {
    const queryParams = new URLSearchParams(this.props.location.search);
    const offCanvas = queryParams.get("offCanvas");

    if (offCanvas) {
      this.setState({ showOffcanvas: true });
    } else {
      this.setState({ showOffcanvas: false });
    }
  };

  getSideBar = () => {
    if (this.props.sidebar_status === "loading") {
      return <Skeleton count={30} />;
    } else if (this.props.sidebar_status === "done") {
      return <Nav />;
    }
  };

  render() {
    let {
      backgroundColor,
      enableBackgroundImage,
      enableSidebarShadow,
      backgroundImage,
      backgroundImageOpacity,
    } = this.props;
    let { showOffcanvas } = this.state;
    return (
      <Fragment>
        <div
          className="sidebar-mobile-overlay"
          onClick={this.toggleMobileSidebar}
        />
        <CSSTransitionGroup
          component="div"
          className={cx("app-sidebar", backgroundColor, {
            "sidebar-shadow": enableSidebarShadow,
            "blur": showOffcanvas,
          })}
          transitionName="SidebarAnimation"
          transitionAppear={true}
          transitionAppearTimeout={1500}
          transitionEnter={false}
          transitionLeave={false}
        >
          <PerfectScrollbar>

              <div data-tut="party-sidebar" className="app-sidebar__inner h-100">
                {this.getSideBar()}

            </div>
          </PerfectScrollbar>
          <div
            className={cx("app-sidebar-bg", backgroundImageOpacity)}
            style={{
              backgroundImage: enableBackgroundImage
                ? "url(" + backgroundImage + ")"
                : null,
            }}
          ></div>
        </CSSTransitionGroup>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  enableBackgroundImage: state.ThemeOptions.enableBackgroundImage,
  enableSidebarShadow: state.ThemeOptions.enableSidebarShadow,
  enableMobileMenu: state.ThemeOptions.enableMobileMenu,
  backgroundColor: state.ThemeOptions.backgroundColor,
  backgroundImage: state.ThemeOptions.backgroundImage,
  backgroundImageOpacity: state.ThemeOptions.backgroundImageOpacity,
  sidebar_status: state.ThemeOptions.sideBarLoadingStatus,
});

const mapDispatchToProps = (dispatch) => ({
  setEnableMobileMenu: (enable) => dispatch(setEnableMobileMenu(enable)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppSidebar))
